module.exports = __webpack_public_path__ + "static/servientrega-76f5611a2b7255721a35fabd1011a2ec.png";